'use strict';
angular.module('atex.dam').factory("AssignService", ['DamService', 'ContentService', '$q',
function (DamService, ContentService, $q) {

  function AssignService( ) {
  }

  AssignService.findGroupById = function(groups, extId) {
    var group = _.find(groups, function(obj) {
      return obj.principalId === extId;
    });
    return group;
  };

  AssignService.findAssigneeById = function(assignees, extId) {
    var assignee = _.find(assignees, function(obj) {
      return obj.externalId === extId;
    });
    return assignee;
  };

  AssignService.isUserOwner = function(userExtId, groups, owners) {
    if (!owners) {
      return false;
    }
    var isOwner = false;
    owners.forEach(function(ownerId){
      if (!isOwner && ownerId === userExtId) {
        isOwner = true;
      }
    });
    if (isOwner) {
      return true;
    }
    // Check if necessary also into groups
    if (!groups) {
      return false;
    }
    groups.forEach(function(group){
      if (!isOwner) {
        var owner = _.find(owners, function(ownerId) {
          return ownerId === group.principalId;
        });
        if (owner) {
          isOwner = true;
        }
      }
    });
    return isOwner;
  };

  AssignService.getOwnersFromAssignees = function(assignees) {
    var owners = [];
    if (assignees) {
      assignees.forEach(function(assignee) {
        if (assignee.owner) {
          owners.push(assignee.externalId);
        }
      });
    }
    return owners;
  };

  AssignService.canUserSeeTheFolder = function(userExtId, groups, assignees) {
    if (!assignees) {
      return false;
    }
    var canSee = false;
    assignees.forEach(function(assignee){
      if (!canSee && assignee.externalId === userExtId) {
        canSee = true;
      }
    });
    if (canSee) {
      return true;
    }
    // Check if necessary also into groups
    if (!groups) {
      return false;
    }
    groups.forEach(function(group){
      if (!canSee) {
        var found = _.find(assignees, function(assignee) {
          return assignee.externalId === group.principalId;
        });
        if (found) {
          canSee = true;
        }
      }
    });
    return canSee;
  };

  AssignService.currentUserIsOwner = function (id) {
    if (!id) {
      return $q.when(true);
    }
    return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      return ContentService.getContent({id: id}).then(function (response) {
        var isOwner = false;
        response.data.aspects['atex.dam.standard.ContentAccess'].data.assignees.forEach(function (assignee) {
          if (isOwner || !assignee.owner) {
            return;
          }
          if (assignee.externalId.indexOf('group') === 0) {
            if (AssignService.findGroupById(currentUserInfo.groups, assignee.externalId)) {
              isOwner = true;
              return;
            }
          } else {
            if (assignee.owner && assignee.externalId === currentUserInfo.externalId) {
              isOwner = true;
              return;
            }
          }
        });
        return isOwner;
      });
    });
  };

  AssignService.unshare = function (id) {
    return DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      return ContentService.getContent({id: id}).then(function (response) {
        var isSharedAsUser = false;
        var isSharedAsGroup = false;
        var newAssignees = [];
        response.data.aspects['atex.dam.standard.ContentAccess'].data.assignees.forEach(function (assignee) {
          if (!isSharedAsGroup && assignee.externalId.indexOf('group') === 0) {
            if (AssignService.findGroupById(currentUserInfo.groups, assignee.externalId)) {
              isSharedAsGroup = true;
            }
          } else {
            if (!isSharedAsUser && assignee.externalId === currentUserInfo.externalId) {
              isSharedAsUser = true;
              return; // return to not add the current assignee to the newAssignees
            }
          }
          newAssignees.push(assignee);
        });
        if (isSharedAsUser) {
          var toSave = angular.copy(response.data);
          toSave.aspects['atex.dam.standard.ContentAccess'].data.assignees = newAssignees;
          var transferInfo = {id: response.id, data: toSave, revision: response.revision};
          return ContentService.updateContent(transferInfo).then(function () {
            // If the content is not shared also to a user's group return true in order to
            // remove the query from the client view
            return !isSharedAsGroup;
          });
        } else {
          // The query is shared only to a user's group
          return false;
        }
      });
    });
  };

  AssignService.prototype = {
    constructor: AssignService
  };

  return(AssignService);

}
]);
